import api from './Api';

const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY || 'BB-Yr4dkfutrlMGvNYnEB_wF9QYt4Z4KIV-wtcYJCOWJPdcUhI4HWFaKzOHmO2f1XdjDKjCrwd9D5FDgi4cZlzA';

function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

export async function subscribeUserToPush() {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;
    if (!VAPID_PUBLIC_KEY) return;

    try {
        const permission = await Notification.requestPermission();
        if (permission !== 'granted') return;

        // ✅ Skip the entire flow if already registered this session
        const alreadySent = sessionStorage.getItem('pushSubscribed');
        if (alreadySent) return;

        const registration = await navigator.serviceWorker.register('/service-worker.js', { scope: '/' });
        await navigator.serviceWorker.ready;

        let subscription = await registration.pushManager.getSubscription();

        if (!subscription) {
            const convertedVapidKey = urlBase64ToUint8Array(VAPID_PUBLIC_KEY);
            subscription = await registration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: convertedVapidKey
            });
        }

        await api.post('/web-push/subscribe', {
            subscription,
            deviceInfo: {
                userAgent: navigator.userAgent,
                platform: navigator.platform
            }
        });

        // ✅ Mark as done for this session so it doesn't re-run on every page load
        sessionStorage.setItem('pushSubscribed', 'true');

    } catch (error) {
        console.error('Failed to subscribe the user: ', error);
    }
}
